import type {EagColumnState} from '../types/EagColumnState';

/**
 * Maps column keys to their <col> DOM index in the colgroup for resize.
 *
 * Right-pinned columns shift by +1 due to the filler <col> between unpinned
 * and right-pinned. hasCheckboxColumn adds +1 to all indices.
 */
export const computeColIndexMap = (
  orderedVisibleColumnStates: EagColumnState[],
  nonRightPinnedCount: number,
  hasCheckboxColumn: boolean
): Map<string, number> => {
  const map = new Map<string, number>();
  const checkboxOffset = hasCheckboxColumn ? 1 : 0;

  for (let i = 0; i < orderedVisibleColumnStates.length; i++) {
    const cs = orderedVisibleColumnStates[i];
    const isRightPinned = cs.pinned === 'RIGHT';
    map.set(
      cs.key,
      isRightPinned
        ? nonRightPinnedCount + 1 + (i - nonRightPinnedCount) + checkboxOffset
        : i + checkboxOffset
    );
  }

  return map;
};
